<!--
/*******************************************************************************
*@ 컴포넌트명   : ModalPop.vue
*@ 컴포넌트설명 : modalPop 공통컴포넌트
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <section v-if="opened">
    <div class="modal" :class="[active]">
      <div class="modal-dialog">
        <div class="modal-content">
          <header v-if="modalHeader" class="modal-header" :class="{ hasborder: modalTopBorder }">
            <div class="modal-title">
              <h5>{{ $t(title) }}</h5>
            </div>
            <button v-if="btnClose" class="btn-close" @click="close()"></button>
            <!-- 서브 타이틀 -->
            <div class="description">
              <slot name="subtitle">
                {{ subtitle }}
                <br v-if="subtitle2" />
              </slot>
              <slot name="subtitle2">
                {{ subtitle2 }}
                <br v-if="subtitle3" />
              </slot>
              <slot name="subtitle3">{{ subtitle3 }}</slot>
            </div>
            <!--// 서브 타이틀 -->
          </header>
          <div v-if="modalBody" class="modal-body">
            <slot name="content"></slot>
          </div>
          <footer
            v-if="modalFooter"
            class="modal-footer"
            :class="{ hasborder: modalBottomBorder, check: modalCheckBox }"
          >
            <div class="btn-area--bottom">
              <slot name="footer">
                <button
                  class="btn bottom negative"
                  v-if="noNegativeButton"
                  @click="cancelClick"
                >{{ $t(cancel) }}</button>
                <button class="btn bottom positive" @click="confirmClick">{{ $t(confirm) }}</button>
              </slot>
            </div>
          </footer>
        </div>
      </div>
    </div>
    <div v-if="noDimClose" class="modal-backdrop"></div>
    <div v-else class="modal-backdrop" @click="close()"></div>
  </section>
</template>
<style type="scss" scoped></style>
<script>
import { BaseComponent } from "@/components/base-component";
import ModalEvent from "@/components/modal-event";

export default {
  name: "modal-pop",
  extends: BaseComponent,
  mixins: [ModalEvent],

  props: {
    // header 사용여부
    modalHeader: { type: [Boolean], default: true },
    modalBody: { type: [Boolean], default: true },
    // footer (버튼) 사용여부
    modalFooter: { type: Boolean, default: true, required: false },
    title: { type: String, default: undefined, required: false },
    subtitle: { type: String, default: undefined, required: false },
    subtitle2: { type: String, default: undefined, required: false },
    subtitle3: { type: String, default: undefined, required: false },
    width: { type: String, default: "100%", required: false },
    height: { type: String, default: "auto", required: false },
    cancel: { type: String, default: "MCOM-0000033", required: false },
    confirm: { type: String, default: "MCOM-0000034", required: false },
    opened: { type: Boolean, default: false },
    btnClose: { type: Boolean, default: false },
    // 부정 버튼 사용 여부
    noNegativeButton: { type: Boolean, default: false },
    // 긍정 버튼 사용 여부
    noPostivieButton: { type: Boolean, default: false },
    // dim 영역 선택시 닫기 이벤트 방지
    noDimClose: { type: Boolean, default: false },
    modalBottomBorder: { type: Boolean, default: false, required: false },
    modalTopBorder: { type: Boolean, default: false, required: false },
    modalCheckBox: { type: Boolean, default: false, required: false },
    // 긍정 버튼 사용시 화면 비동기 닫음
    beforeConfirm: {
      type: Function,
      default: () => {
        return true;
      },
      required: false,
    },
  },
  data() {
    return {
      active: "",
    };
  },
  computed: {
    hasCloseListener() {
      return this.$listeners && this.$listeners["close-button-clicked"];
    },
    uid() {
      return this._uid;
    },
  },
  watch: {
    opened: {
      handler(newData) {
        if (newData) {
          if (process.browser) {
            this.removeBodyScroll();
          }
          this.active = "show";
        } else {
          if (process.browser) {
            this.addBodyScroll();
          }
          this.active = "fade";
        }
      },
    },
  },
  beforeDestroy() {
    if (process.browser) {
      this.addBodyScroll();
    }
  },
  methods: {
    close() {
      if (this.hasCloseListener) {
        this.$emit("close-button-clicked", () => this.done());
      } else {
        this.$emit("close");
        this.done();
      }
    },
    done() {
      this.$emit("update:opened", false);
    },
    confirmClick() {
      if (!this.beforeConfirm()) return;

      this.$emit("confirm");
      this.done();
    },
    cancelClick() {
      this.$emit("cancel");
      this.done();
    },
  },
};
</script>